import { send } from '../../../../../../src/network/network';
import { type ResetPlan } from '../../../../../../src/types/ResetPlan';

export type ResetPlanParams = {
  customerId: number;
};

/**
 * Deactivates a pre-checkout customer's active plan without touching their
 * quiz, dietary restrictions, tags, goals, or occasion preferences (BE-8695).
 * Called right after a locally stored quiz is persisted on login so the later
 * `reset_survey` on the plan page is a no-op and the customer gets a fresh
 * plan on their current pricing version.
 *
 * `{ reset: false }` when there is no active plan or the customer is already
 * on a recent pricing version; 403 for post-checkout customers.
 */
export async function postApiV2CustomersCustomerIdResetPlan({
  customerId,
}: ResetPlanParams) {
  return await send<ResetPlan>({
    path: `/api/v2/customers/${customerId}/reset_plan/`,
    method: 'POST',
  });
}
